import React from 'react'
import { Layout } from 'ui/layout/Layout'
import CenteredContainer from 'ui/layout/CenteredContainer'
import { AppBarCommon } from 'ui/partials/AppBar'

/**
 * 基本情報などを読み込む前に表示するグレー背景のみの画面
 */
const Loading: React.FC = () => {
  return (
    <Layout header={<AppBarCommon type="personal" />} showFooter>
      <CenteredContainer />
    </Layout>
  )
}

export default Loading
